document.addEventListener("DOMContentLoaded", function () {
  var sizeGuideTrigger = document.getElementById("size_guide_popup_trigger");
  var sizeGuideCloseTrigger = document.getElementById("size-guide_popup_close");

  sizeGuideTrigger.addEventListener("click", function (event) {
    event.preventDefault();
    openSizeGuidePopup();
  });
  sizeGuideCloseTrigger.addEventListener("click", function (event) {
    event.preventDefault();
    closeSizeGuidePopup();
  });
  document.querySelectorAll(".size_guide_nav_item").forEach((item) => {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      const unitSystem = this.classList.contains("imperial")
        ? "imperial"
        : "metric";
      changeSizeGuideTab(unitSystem);
    });
  });
});
function openSizeGuidePopup() {
  var sizeGuidePop = document.getElementById("size-guide_popup");
  const overlayElement = document.querySelector("[data-site-overlay]");
  sizeGuidePop.style.display = "block";
  overlayElement.classList.add("show");
  document.body.classList.add("body-hidden");
}
function closeSizeGuidePopup() {
  var sizeGuidePop = document.getElementById("size-guide_popup");
  const overlayElement = document.querySelector("[data-site-overlay]");
  sizeGuidePop.style.display = "none";
  overlayElement.classList.remove("show");
  document.body.classList.remove("body-hidden");
}
function changeSizeGuideTab(name) {
  if (!name) {
    return;
  }
  document.querySelectorAll(".size_guide_table").forEach((item) => {
    item.classList.remove("active");
  });
  document.querySelectorAll(".size_guide_nav_item").forEach((item) => {
    item.classList.remove("active");
  });
  document.querySelector(".size_guide_table_" + name).classList.add("active");
  document
    .querySelector(".size_guide_nav_item." + name)
    .classList.add("active");
}
